import React from 'react';
import { useHistory } from 'react-router-dom';
import { Tile } from '../../tiles/tile';
import { TileContainer } from '../../tiles/container';
import VisitorAgreements from '../../../images/VisitorAgreement.jpg';
import Questionnaires from '../../../images/Questionnaires.jpg';
import Sites from '../../../images/Sites.jpg';
import Theme from '../../../images/Theme.jpg';
import License from '../../../images/License.jpg';
import Settings from '../../../images/Settings.jpg';
import VisitorTypes from '../../../images/VisitorTypes.jpg';
import { useAuthentication } from '../../authentiction';

const AdminDashboardPage: React.FC = () => {
  const history = useHistory();
  const { licenseHasExpired, hasValidLicense } = useAuthentication();

  const showSettings = !licenseHasExpired && hasValidLicense;

  return (
    <TileContainer>
      <Tile
        icon="file-contract"
        heading="Visitor Agreements"
        image={VisitorAgreements}
        content="Configure terms & conditions, health & safety notices, non-disclosure agreements and welcome messages for visitors."
        onClick={() => history.push('/admin/visitorAgreements')}
      />
      <Tile
        icon="users"
        heading="Visitor Types"
        image={VisitorTypes}
        content="Create and edit visitor categories such as Visitor, Contractor and Drivers."
        onClick={() => history.push('/admin/visitorTypes')}
      />
      <Tile
        icon="question"
        heading="Questionnaires"
        image={Questionnaires}
        content="Create and edit admission questions for visitors."
        onClick={() => history.push('/admin/questionnaires')}
      />
      <Tile
        icon="building"
        heading="Sites"
        image={Sites}
        content="Setup your reception locations and link them to Visitor Types, Agreements, Questionnaires and Email addresses."
        onClick={() => history.push('/admin/sites')}
      />
      <Tile
        icon="image"
        heading="Theme"
        image={Theme}
        content="Modify your VisIT display images and colour scheme to be used on the welcome screen."
        onClick={() => history.push('/admin/themes')}
      />
      <Tile
        icon="file-certificate"
        heading="Update License"
        image={License}
        content="Activate your VisIT product or apply a new license."
        onClick={() => history.push('/admin/license')}
      />
      {showSettings && (
        <Tile
          icon="cog"
          heading="Settings"
          image={Settings}
          content="Configure data retention, auto sign out."
          onClick={() => history.push('/admin/settings')}
        />
      )}
    </TileContainer>
  );
};

export default AdminDashboardPage;
